import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../services/auth/auth.service';
import { MIN_STATUS, RESULT_URL } from '../../utils/constants';

@Injectable()
export class EconomicStudyAccessGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (environment.disableGuards) {
      return true;
    }

    if (
      parseFloat(this.authService.getStatus().getValue()) >= MIN_STATUS.saveData &&
      parseFloat(this.authService.getStatus().getValue()) !==
        MIN_STATUS.waitingAceptedSecondHolder &&
      parseFloat(this.authService.getStatus().getValue()) < MIN_STATUS.attachDocumentation
    ) {
      this.authService.updateStatus(true);
      return true;
    }

    this.router.navigate([RESULT_URL]);
    return;
  }
}
